import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupByDateProperty',
  
})
export class GroupByDatePropertyPipe implements PipeTransform {

  transform(collection: Array<any>, property: string): Array<any> {
    //console.log(property);
    if(!collection) {
        return null;
    }

    const mappedCollection = collection.map(game => ({
      ...game, 
      //GroupDate: game[property].split('T')[0]
      GroupDate: game[property].split('T')[0]
    }));

    //console.log("mappedCollection");
    //console.log(mappedCollection);
   
    const gc = mappedCollection.reduce((previous, current)=> {
        if(!previous[current['GroupDate']]) {
            previous[current['GroupDate']] = [];
        }
      
        previous[current['GroupDate']].push(current);
        return previous;
    }, {});
    //console.log(Object.keys(gc).map(date => ({ GroupDate: date, Games: gc[date] })));
    return Object.keys(gc).map(date => ({ GroupDate: date, Games: gc[date] }));
    }  

}
